import { render } from "./InformacoesCrm.vue?vue&type=template&id=695de2ea"
import script from "./InformacoesCrm.vue?vue&type=script&lang=js"
export * from "./InformacoesCrm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__